export default __webpack_public_path__ + "static/media/Group9241.5b53a9cc.svg";